import {
  CapaConsultingStartMethod,
  CapaQuotationProductPurpose,
  CapaQuotationServiceType,
  CapaRfqPcbMaterialSupplyMethodType,
  RegisterRfqPcbInput
} from '@generated/graphql';
import { Action, IRequestState, UploadedDrawingFileType } from './types';
import { RfqReferenceFileInput } from '@generated/graphql';
import { createReducer } from 'typesafe-actions';
import {
  ALL_UPDATE_RFQ_FILE,
  BATCH_UPDATE_RFQ_FILE,
  COMPLETE_RFQ,
  CREATE_REFERENCE_FILE,
  CREATE_RFQ_FILE,
  DELETE_REPRESENTIVE_IMAGE,
  DELETE_RFQ_FILE,
  INIT_RFQ_STATE,
  UPDATE_COMPLETE_RFQ,
  UPDATE_RFQ_FILE,
  UPDATE_RFQ_INFO,
  UPLOAD_REPRESENTIVE_IMAGE,
  UPDATE_PCB_ASSEMBLY_FILE,
  UPDATE_PCB_FABRICATION_FILE
} from './actions';

// initialState
export const initialState: IRequestState = {
  uploadedDrawingFiles: [],
  uploadedReferenceFiles: [],
  isComplete: false,
  rfqId: '',
  serviceType: '' as CapaQuotationServiceType,
  drawingFiles: [],
  detailedRequest: '',
  referenceFiles: [],
  projectName: '',
  dueDate: '',
  dueNegotiable: false,
  maxEstimatedBudget: 0,
  minEstimatedBudget: 0,
  budgetOpen: true,
  detailed_request: '',
  projectPurpose: '' as CapaQuotationProductPurpose,
  projectPurposeDetail: '',
  optionalServices: [],
  publicOpen: true,
  manufacturingStage: undefined,
  pcb: {
    services: [],
    assemblyFiles: [],
    assemblyMethod: [],
    assemblyQuantity: null,
    materialSupplyMethod: CapaRfqPcbMaterialSupplyMethodType.CustomerSupply,
    metalMaskAvailablity: true,
    fabricationFiles: [],
    fabricationQuantity: null
  } as RegisterRfqPcbInput,
  prototypeQuantity: null,
  requestPrototyping: null,
  preRfqId: null,
  consultingStartMethod: CapaConsultingStartMethod.QuotationRequired
};

// reducer
export const request = createReducer<IRequestState, Action>(initialState, {
  [CREATE_RFQ_FILE]: (state, action) => {
    const files: UploadedDrawingFileType = {
      ...action.payload,
      isValid: false
    };
    return {
      ...state,
      uploadedDrawingFiles: [...state.uploadedDrawingFiles, files]
    };
  },
  [CREATE_REFERENCE_FILE]: (state, action) => {
    const file = action.payload;

    return {
      ...state,
      uploadedReferenceFiles: [...state.uploadedReferenceFiles, file]
    };
  },
  [UPLOAD_REPRESENTIVE_IMAGE]: (state, action) => {
    const file = action.payload;
    const fileWithoutSize = {
      ...file,
      size: undefined
    } as RfqReferenceFileInput;

    return {
      ...state,
      referenceFiles: [...(state.referenceFiles ?? []), fileWithoutSize],
      uploadedReferenceFiles: [file, ...state.uploadedReferenceFiles]
    };
  },
  [DELETE_REPRESENTIVE_IMAGE]: (state) => {
    const currentRefFiles = [...state.uploadedReferenceFiles];
    currentRefFiles.pop();
    return {
      ...state,
      referenceFiles: [],
      uploadedReferenceFiles: [...currentRefFiles]
    };
  },
  [DELETE_RFQ_FILE]: (state, action) => {
    const files =
      state.uploadedDrawingFiles?.filter(
        (file) => file.fileId !== action.payload
      ) ?? [];
    return { ...state, uploadedDrawingFiles: files };
  },

  [UPDATE_RFQ_FILE]: (state, action) => {
    const files =
      state.uploadedDrawingFiles?.map((file) => {
        if (file.fileId !== action.payload.fileId) return file;
        return { ...file, ...action.payload, isValid: true };
      }) ?? [];
    return { ...state, uploadedDrawingFiles: [...files] };
  },

  [ALL_UPDATE_RFQ_FILE]: (state, action) => {
    const files = action.payload;
    return {
      ...state,
      uploadedDrawingFiles: [...files],
      isComplete: true
    };
  },

  [BATCH_UPDATE_RFQ_FILE]: (state, action) => {
    const payload = action.payload;
    const uploadedDrawingFiles = state.uploadedDrawingFiles ?? [];

    delete payload.fileId;
    delete payload.fileName;

    return {
      ...state,
      uploadedDrawingFiles: uploadedDrawingFiles.map((file) => {
        return {
          fileId: file.fileId,
          fileName: file.fileName,
          ...payload,
          isValid: true
        };
      }),
      isComplete: true
    };
  },

  [UPDATE_RFQ_INFO]: (state, action) => {
    return { ...state, ...action.payload };
  },

  [COMPLETE_RFQ]: (state) => {
    return {
      ...state,
      isComplete: true
    };
  },

  [UPDATE_COMPLETE_RFQ]: (state, action) => {
    return { ...state, isComplete: action.payload };
  },

  [INIT_RFQ_STATE]: (state) => {
    return { ...initialState };
  },
  [UPDATE_PCB_FABRICATION_FILE]: (state, action) => {
    return {
      ...state,
      pcb: {
        ...state.pcb,
        fabricationFiles: action.payload
      }
    } as IRequestState;
  },
  [UPDATE_PCB_ASSEMBLY_FILE]: (state, action) => {
    return {
      ...state,
      pcb: {
        ...state.pcb,
        assemblyFiles: action.payload
      }
    } as IRequestState;
  }
});
